import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import _ from "lodash";
import PropTypes from "prop-types";
import { resolveEditPermission } from '../../../utils/mappers/workspace';
import { getSafeSelectedWorkspace } from '../../../utils/mappers/user'
import  EventGroup  from "./EventGroup";
import EditEventGroup from "./EditEventGroup";
import "./EditGroup.css"
import { getGenericGroups, saveGenericGroup, editGenericGroup, removeGenericGroup} from "../../../actions/genericGroups";

import {
  Modal,
  Header,
  Button,
  Grid,
  ModalContent,
  Segment,
  ModalActions,
  Loader,
  Dimmer,
  
} from "semantic-ui-react";

import { useTranslation } from "react-i18next";


export const EventGroupModal = ({
    groups, 
    columns,
    items,
    currentWorkspaceId,
    closeModal,
    canEditCurrentWorkspace,
    saveGenericGroup,
    editGenericGroup,
    removeGenericGroup,
    genericGroupRequestBegin,
    genericGroupRequestAbort,

}) => {
    const { t } = useTranslation();
    const [ , setShowEditEventGroup ] = useState(false) 
    const [ selectedEventGroup, setSelectedEventGroup ] = useState(null)
    const [ creatingNewEventGroup, setCreatingNewGroup ] = useState(false)
    
    useEffect(() => {
        
      }, [currentWorkspaceId, groups, genericGroupRequestBegin, genericGroupRequestAbort]);
    const groupNames = groups.length !== 0 ? groups.map(group => group.name): []
    const isLoaderActive = genericGroupRequestBegin || genericGroupRequestAbort
    const deleteEventGroup = (eventGroup) => {
        if (!canEditCurrentWorkspace){
            return
        }
        removeGenericGroup(currentWorkspaceId, eventGroup.id)
    }

    return (
        <Modal
        className="group-edition-container"
        open={true}
        >
            {(isLoaderActive ) && (
                <Dimmer active inverted>
                    <Loader></Loader>
                </Dimmer>)}
             <ModalContent className="event-group-modal-content">
                <Header>{t("calendar.events.eventGroups")}</Header>
                <Segment className="event-groups-container" >
                    
                    <Grid style={{width:"100%"}}>
                        {_.isNil(selectedEventGroup) && !creatingNewEventGroup ?
                        <Grid.Row centered className="group-settings-add-button-container">
                            <Button
                                disabled={!canEditCurrentWorkspace && columns.length !== 0}
                                primary
                                onClick={() => {
                                    if (!canEditCurrentWorkspace) {
                                    return;
                                    }
                                    setShowEditEventGroup(true);
                                    setCreatingNewGroup(true)
                                    
                                }}
                            >
                            {t("groupSettings.addNew")}
                            </Button>
                        </Grid.Row>:
                        null
                        }
                        <Grid.Row>
                            {_.isNil(selectedEventGroup) && !creatingNewEventGroup ?
                            <div className="event-groups-list">
                                {groups.map((group) => {
                                    return(
                                        <EventGroup
                                            key={group.id}
                                            editable={true}
                                            groupProps={group}
                                            onEditClick={{setShowEditEventGroup, setSelectedEventGroup}}
                                            onRemoveClick={()=>{deleteEventGroup(group)}}
                                        />
                                    )
                                })}
                            </div>:
                            <EditEventGroup
                                groupNames={groupNames}
                                selectedGroup={selectedEventGroup}
                                columns={columns}
                                items={items}
                                closeEditEventGroup={{setCreatingNewGroup, setSelectedEventGroup}}
                                onSave={async (groupData) => {
                                    if (_.isEmpty(selectedEventGroup)) {
                                        await saveGenericGroup(
                                        currentWorkspaceId,
                                        groupData,
                                        );
                                    } else {
                                        await editGenericGroup(
                                        currentWorkspaceId,
                                        groupData,
                                        );
                                    }
                                    setSelectedEventGroup(null);
                                    }}
                                    onCancel={() => {
                                    setSelectedEventGroup(null);
                                    }}
                                

                            />
                            }
                        </Grid.Row>
                    </Grid>
                </Segment>
            </ModalContent>
            <ModalActions>
                {_.isNil(selectedEventGroup) && !creatingNewEventGroup ?
                <Button
                    onClick={()=> {closeModal(false)}}

                >{t("cancel")}</Button>:
                null
            }
                

            </ModalActions>
            
        </Modal>
    )   
};
EventGroupModal.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  items: PropTypes.array,
  closeModal: PropTypes.func,
  canEditCurrentWorkspace: PropTypes.func,
  saveGenericGroup: PropTypes.func,
  editGenericGroup: PropTypes.func,
  removeGenericGroup: PropTypes.func,
  columns: PropTypes.array,
  showEventGroups: PropTypes.bool,
  currentWorkspaceId: PropTypes.number,
  genericGroupRequestAbort: PropTypes.bool,
  genericGroupRequestBegin: PropTypes.bool
};

EventGroupModal.defaultProps = {
  showEventGroups:  false,
  columns: PropTypes.object,
};

const mapStateToProps = (state) => ({
    groups: state.genericGroups.genericGroups,
    items: state.items.items,
    columns: state.dataset.columns,
    currentWorkspaceId: getSafeSelectedWorkspace(state),
    canEditCurrentWorkspace:
        state.auth.isConnected &&
        resolveEditPermission(state.auth.user, getSafeSelectedWorkspace(state)),
    workspaces: state.workspace.workspaces,
    selectedWorkspaceIds: state.calendar.selectedWorkspaceIds,
    genericGroupRequestBegin: state.genericGroups.genericGroupRequestBegin,
    genericGroupRequestAbort: state.genericGroups.genericGroupRequestAbort,

})

export default connect(mapStateToProps, {
    getGenericGroups,
    saveGenericGroup,
    editGenericGroup,
    removeGenericGroup,
})(EventGroupModal)
